module.exports = __webpack_public_path__ + "img/try_again.3a935b16.svg";